import React from 'react'
import './FeatureCard.css'

const FeatureCard = ({ title, icon, descn,bgcolour }) => {
    return (
        <section className='FeatureCard' style={{background:bgcolour}}>

            
            <div className='heading_holder'>
                <p className='title'>{title}</p>
            </div>

            <div className='descn_holder'>
                <p className='descn'>{descn}</p>
            </div>

            <div className='icon_holder'>
                <img src={icon} className='icon_img'/>
            </div>

        </section>
    )
}

export default FeatureCard
